export default "__VITE_ASSET__BxGozASD__"